import { Injectable, Injector } from '@angular/core';
import { SgEntitySelectFetchStore } from '../components/entity-select-auto-complete';
import { CountryApiToEntityFetcherLink, CountryApiISO2ToEntityFetcherLink } from './entity-country';
import { CompositeBbgIdApiToEntityFetcherLink } from './entity-security';
import { CurrencyApiToEntityFetcherLink } from './entity-currency';
import { CompanyApiToEntityFetcherLink, CompanyByNameApiToEntityFetcherLink } from './entity-company';
import { IsinApiToEntityFetcherLink } from './entity-isins';
import { CompositeTickerApiToEntityFetcherLink } from './entity-ticker';
import { LegalEntityApiToEntityFetcherLink, LegalEntityByNameToEntityFetcherLink } from './entity-legal-entities';
import { LegalEntitySimpleApiToEntityFetcherLink } from './entity-legal-entities-simple';
import { AccountsToEntityFetcherLink } from './entity-bank-accounts';
import { AccountsByIdToEntityFetcherLink } from './entity-accounts-by-id';
import { UsersApiToEntityFetcherLink, UsersNameApiToEntityFetcherLink } from './entity-user';
import { AccountByIdMinorsOnlyToEntityFetcherLink } from './entity-account-by-id-minors-only';
import { PartnersAndClientsApiToEntityFetcherLink } from './entity-partners-and-clients';
import { ClientIntegrationApiToEntityFetcherLink } from './entity-client-integrations';
import { LegalEntityGroupApiToEntityFetcherLink } from './entity-legal-entity-group';
import { TransmissionApiToEntityFetcherLink } from './enity-transmission';
import { RecipientApiToEntityFetcherLink } from './entity-recipient';
import { AccountBySafekeepingAccountToEntityFetcherLink } from './entity-account-by-safekeeping-account';

/**
 * This linker is used to link between the various api interface's on the server and the `SgEntitySelectFetchStore` by creating
 * entity adapter to all entities exposed by the each API.
 *
 * This is a generic API interface for the `sg-entity-select-auto-complete` component (or any other code that use it).
 */
@Injectable({ providedIn: 'root' })
export class SgApisToEntityFetcherLinker {
  constructor(private entityStore: SgEntitySelectFetchStore) {}

  define(injector: Injector, app?: 'Admin' | 'EMT'): Promise<void> {
    switch (app) {
      case 'Admin':
        return this.defineAdmin(injector);
      case 'EMT':
        return this.defineEMT(injector);
      default:
        break;
    }
  }

  defineAdmin(injector: Injector): Promise<void> {
    this.entityStore.registerEntityFetcher(new CountryApiToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new CountryApiISO2ToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new CompositeBbgIdApiToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new CurrencyApiToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new CompanyApiToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new CompanyByNameApiToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new LegalEntityApiToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new LegalEntityByNameToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new LegalEntitySimpleApiToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new IsinApiToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new CompositeTickerApiToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new AccountsToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new AccountsByIdToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new AccountByIdMinorsOnlyToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new UsersNameApiToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new UsersApiToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new ClientIntegrationApiToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new LegalEntityGroupApiToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new TransmissionApiToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new RecipientApiToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new PartnersAndClientsApiToEntityFetcherLink(injector));
    return Promise.resolve();
  }

  defineEMT(injector: Injector): Promise<void> {
    this.entityStore.registerEntityFetcher(new LegalEntityApiToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new LegalEntityByNameToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new AccountsToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new AccountsByIdToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new AccountBySafekeepingAccountToEntityFetcherLink(injector));
    this.entityStore.registerEntityFetcher(new AccountByIdMinorsOnlyToEntityFetcherLink(injector));
    return Promise.resolve();
  }
}
